module.exports = __webpack_public_path__ + "static/img/10.ebf118f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/10.png
// module id = tC4R
// module chunks = 0